<!--
Author: TangChen
Date: 2018-12-08
Desc: 基金赎回，由index.js 配置引入
-->
<template>
    <div>
        <div class="bor_E4E4E4">
            <comp-title :title="title">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home' }">我的资产</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
                </el-breadcrumb>
            </comp-title>
            <el-form
                v-show="!buySuccess"
                ref="fundInfo"
                :model="fundInfo"
                :rules="rules"
                label-width="260px"
                class="pwdForm"
                inline-message
                v-on:submit.native.prevent
            >
                <el-form-item label="基金名称：" class="form-text">
                    <div class="text-con">
                        {{ fund.fundname + "(" + fund.fundcode + ")" }}
                    </div>
                </el-form-item>
                <el-form-item label="收费方式：" prop="way" class="form-text">
                    <el-select v-model="fundInfo.sharetype" :disabled="fund.sharetype !== 'A,B'">
                        <el-option value="A" label="前收费"></el-option>
                        <el-option value="B" label="后收费"></el-option>
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            前端收费是在申购基金时收取申购费,
                            <br />
                            而后端收费则是在申购时不收费，
                            <br />
                            在赎回时才收取手续费用。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="赎回到：" prop="sellTo" class="payway-list">
                    <div class="flex lin20">
                        <div
                            v-if="hasxjb && xjbfundcode !== fund.fundcode"
                            class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 mr20 relative pointer"
                            v-on:click="fundInfo.sellTo = '1'"
                        >
                            <div class="fs18 c_333 mb10">大成钱柜</div>
                            <div class="c_999 fs14">
                                最新七日年化收益率:{{
                                    $util.isEmpty(growthrate) ? "--" : $util.fmtNum(growthrate, 4)
                                }}%。
                            </div>
                            <div class="c_999 fs14">买基金立享优惠</div>
                            <img
                                src="../../assets/img/recommend.png"
                                class="absolute w65 h65 _t2 _r2"
                            />
                            <div
                                v-if="fundInfo.sellTo === '1'"
                                class="bc_E60012 h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"
                            >
                                <img
                                    src="../../assets/img/square-checked-white.png"
                                    class="w16 h12"
                                />
                            </div>
                        </div>
                        <div
                            class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 relative pointer"
                            v-on:click="fundInfo.sellTo = '2'"
                        >
                            <div class="fs18 c_333 mb10">银行卡</div>
                            <div class="c_999 fs14">银行活期存款利率：0.35%。</div>
                            <div class="c_999 fs14">若不急需现金，建议转至钱柜</div>
                            <div
                                v-if="fundInfo.sellTo === '2'"
                                class="bc_E60012 h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"
                            >
                                <img
                                    src="../../assets/img/square-checked-white.png"
                                    class="w16 h12"
                                />
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="回款账号：" prop="id" class="payway-list">
                    <el-radio-group v-model="fundInfo.id" class="bank-radio">
                        <el-radio
                            v-for="bank in fund.fundArr"
                            :key="bank.transactionaccountid + bank.index"
                            :label="bank.transactionaccountid + bank.index"
                            :disabled="bank.paycenterid === $util.getConfig().const.ZX_CENTER"
                            border
                            v-on:mouseenter.native="
                                bank.paycenterid === $util.getConfig().const.ZX_CENTER
                                    ? (hover = true)
                                    : ''
                            "
                            v-on:mouseleave.native="
                                bank.paycenterid === $util.getConfig().const.ZX_CENTER
                                    ? (hover = false)
                                    : ''
                            "
                        >
                            <div class="bank-img-sel">
                                <img
                                    :src="
                                        $util.getImg(
                                            bank.paycenterid !== $util.getConfig().const.ZX_CENTER
                                                ? bank.bankcode
                                                : 'xh'
                                        )
                                    "
                                    alt=""
                                />
                                <div
                                    v-if="
                                        bank.paycenterid === $util.getConfig().const.ZX_CENTER &&
                                        hover
                                    "
                                    class="k-text-flow"
                                >
                                    <span class="zx-balance">直销柜台渠道份额需到直销柜台赎回</span>
                                </div>
                                <div v-else class="k-text-flow">
                                    <span
                                        class="bank-name"
                                        :title="$cache.getDict('110080', bank.bankcode)"
                                    >
                                        {{ $cache.getDict("110080", bank.bankcode) }}({{
                                            bank.depositcard.substr(-7, 7)
                                        }})
                                    </span>
                                    总额(份)：
                                    <span class="bank-balance">
                                        {{ $util.fmtNum(bank.usableremainshare) }}
                                    </span>
                                </div>
                                <i class="el-icon-check" aria-hidden="true" />
                            </div>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="可用份额：" class="form-text red">
                    <div class="text-con">
                        {{ $util.fmtNum(bankInfo.usableremainshare) + "份" }}
                        <span class="freeze">
                            (冻结份额：{{ $util.fmtNum(bankInfo.freezeremainshare) }}份)
                        </span>
                    </div>
                </el-form-item>
                <el-form-item
                    label="赎回份额："
                    prop="amount"
                    class="redemp-amount"
                    :class="{ 'form-text': !isPwdCheck && fundInfo.sellTo === '1' }"
                >
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                    />
                    <span v-if="!isAmountAll" class="redemp-btn" v-on:click.prevent="allSell">
                        <span class="like-a">全部赎回</span>
                    </span>
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="份额确认：">
                    {{ $util.capitalShare(fundInfo.amount, "份") }}
                </el-form-item>
                <el-form-item v-if="fund.fundtype !== '2'" label="巨额赎回处理：">
                    <el-select v-model="fundInfo.largeredemptionflag">
                        <el-option label="放弃超额部分" value="0" />
                        <el-option label="继续赎回" value="1" />
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            单个开放日中，如果一只基金的净赎回申请超过该基金上一日基金总份额的10％时，即认为该基金发生了巨额赎回。
                            <br />
                            如果遇到巨额赎回，则提交的赎回份额会按一定比例赎回。
                            <br />
                            如果选择“放弃超额部分”则放弃赎回剩余部分。
                            <br />
                            如果选择“继续赎回”则剩余部分会作为下一工作日的赎回申请继续赎回。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item
                    v-show="showSellType"
                    label="赎回方式："
                    prop="sell"
                    class="payway-list"
                >
                    <el-radio-group v-model="fundInfo.sell">
                        <el-radio label="0" name="sell">普通赎回</el-radio>
                        <el-radio label="1" name="sell">
                            快速赎回
                            <span>(预计2小时到账，不享受当天收益)</span>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item v-show="feeGate.estimatedcost" label="预估手续费：" class="form-text">
                    <div class="text-con">
                        <span class="red">{{ $util.fmtNum(feeGate.estimatedcost) }}元</span>
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="isPwdCheck"
                    label="交易密码："
                    prop="pwd"
                    :class="{ 'form-text': fundInfo.sellTo === '1' }"
                >
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="20"
                    />
                    <!--                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>-->
                </el-form-item>
                <el-form-item>
                    <div>
                        <span class="c_E60012">
                            基金赎回会产生一定费用，若持有时间小于7日，将收取1.5%的赎回手续费。
                        </span>
                        <a
                            target="_blank"
                            :href="
                                'https://www.dcfund.com.cn/main/fund/productdetail/index.shtml?product_code=' +
                                fund.fundcode
                            "
                        >
                            点击查看费率>>>
                        </a>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="width: 50%">
                        <el-button class="medium bc_E4E4E4 c_666666" v-on:click="$router.back()">
                            上一步
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium"
                            v-on:click="submitInfo('fundInfo')"
                        >
                            确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <result
                v-if="buySuccess"
                :result="result"
                v-on:return-page="$router.push({ name: 'traderecord' })"
                v-on:return-login="$router.push({ name: 'home' })"
            />
            <fund-protocol v-model="protocol" :fund="xjbFundRisk" v-on:all-read="sellFund" />
        </div>
        <footerQuestions :common-question="commonQuestion"></footerQuestions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import fundProtocol from "@/components/form/fundProtocol";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";
export default {
    name: "SellFund",
    components: {
        result,
        fundProtocol,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            fundInfo: {
                amount: "",
                id: "",
                sell: "",
                sharetype: "",
                sellTo: "",
                pwd: "",
                largeredemptionflag: "1"
            },
            protocol: false,
            isPwdCheck: false,
            isAmountAll: false,
            pla: "请先选择回款账号",
            fund: {}, // 基金信息获取
            sellLimit: {},
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的基金赎回申请已提交成功！",
                btnMsg: "预计确认时间：2018-11-16，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "查看交易记录",
                    event: "return-page"
                },
                btnR: {
                    text: "返回我的资产",
                    event: "return-login"
                }
            },
            bankLists: [],
            xjbFundRisk: {}, // 现金宝适当性信息检查
            query: null,
            rules: {
                amount: [{ validator: this.amountLimit, trigger: "change" }],
                id: [{ required: true, message: "请选择回款账号", trigger: "change" }],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "change" }],
                largeredemptionflag: [
                    { required: true, message: "请选择巨额赎回处理方式", trigger: "change" }
                ]
            },
            limit: { min: "0.01", max: "0", text: "赎回份额范围为：" },
            bankInfo: {},
            feeGate: {},
            hover: false,
            redeemInfo: {}, // 产品限额
            fastRedeemData: {}, // 快赎限额
            showSellType: false, // 是否展示快赎
            commonQuestion: [
                {
                    title: "什么是大成钱柜？",
                    answer:
                        "<div>\n" +
                        '    \t大成钱柜是专为网上交易客户设计的现金管理和投资工具，赎回到“大成钱柜”，实质是购买了大成添利宝E(000726)，可享受货币基金收益。<br><a target="_blank" href="http://www.dcfund.com.cn/promote/2017/currencytool/index.html">更多详情>><a/></div>',
                    showFlag: false
                },
                {
                    title: "我在银行赎回基金，要多久到账？",
                    answer: "货币型基金、理财产品T+1个工作日划款，标普500基金、纳斯达克基金T+7个工作日划款，其他基金T+2个工作日划款。我们将直接划款到银行，然后由银行划款到您账户。到帐速度看银行内部的划款速度。",
                    showFlag: false
                },
                {
                    title: "赎回到账金额是如何计算的？",
                    answer: "<div>赎回费用＝赎回当日基金净值×赎回份额×赎回费率<br>赎回金额=赎回当日基金单位资产净值×赎回份额－赎回费用<div/> ",
                    showFlag: false
                },
                {
                    title: "赎回费率是多少？是否有优惠？赎回费率是多少？是否有优惠？",
                    answer: "<div>一般基金赎回费率按持有年限收取。请您点选具体的基金，在相应基金的页面中点击该基金的“费率”标签，在“赎回费率”部分查看该基金的赎回费率。<br>货币基金没有赎回费。<div/> ",
                    showFlag: false
                },
                {
                    title: "开放式基金的赎回费如何计算？",
                    answer:
                        "<div>开放式基金的赎回费用及金额计算方法如下：<br>赎回费用=赎回份额×T日基金单位净值×赎回费率\n" +
                        "            <br>赎回金额=赎回份额×T日基金单位净值-赎回费用<br>假如投资者赎回1000份基金单位，假设赎回费率为0.5％，当日的基金单位资产净值为1元，其得到的赎回金额为： <br>赎回费用=1000×1×0.5％=5元\n" +
                        "            <br>赎回金额=1000×1-5=995元<div/>",
                    showFlag: false
                },
                {
                    title: "什么是巨额赎回？",
                    answer:
                        "<div>单个开放日中，如果一只基金的净赎回申请超过该基金上一日基金总份额的10％时，即认为该基金发生了巨额赎回。\n" +
                        "            如果遇到巨额赎回，则提交的赎回份额会按一定比例赎回，如果选择“放弃超额部分”则放弃赎回剩余部分，如果选择“继续赎回”则剩余部分会作为下一工作日的赎回申请继续赎回。<div/>",
                    showFlag: false
                }
            ],
            xjbfundcode: "",
            growthrate: "", // 现金宝七日年化
            hasxjb: false // 是否可以赎回到大成钱柜
        };
    },
    watch: {
        "fundInfo.id"(val) {
            this.bankInfo = this.fund.fundArr.filter((item) => {
                return item.transactionaccountid + item.index === val;
            })[0];
            let _max =
                this.fundInfo.sell === "0"
                    ? Number(this.bankInfo.usableremainshare) >
                      Number(this.redeemInfo.maxredemptionvol)
                        ? this.redeemInfo.maxredemptionvol
                        : this.bankInfo.usableremainshare
                    : Number(this.bankInfo.usableremainshare) >
                      Number(this.fastRedeemData.maxfastredeem)
                    ? this.fastRedeemData.maxfastredeem
                    : this.bankInfo.usableremainshare;
            if (Number(_max) === 0 || this.$util.isEmpty(_max)) {
                // 没返回最大限额，最大值为可用份额
                _max = this.bankInfo.usableremainshare;
            }
            this.$set(this.limit, "max", _max);
            this.pla =
                Number(this.limit.min) < Number(_max)
                    ? "本次可赎回" +
                      this.$util.fmtNum(this.limit.min) +
                      "-" +
                      this.$util.fmtNum(_max) +
                      "份"
                    : "本次只可全部赎回剩余份额";
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
                this.queryRate();
            }
            this.queryFundlimit();
        },
        /* 赎回类型   0-普通赎回 1-快速赎回 */
        "fundInfo.sell"(val) {
            if (this.fundInfo.sell === "1") {
                this.isPwdCheck = this.$cache.getPwdCheck("98");
            } else {
                this.isPwdCheck = this.$cache.getPwdCheck("24");
            }
            const _max =
                val === "0"
                    ? Number(this.bankInfo.usableremainshare) >
                      Number(this.redeemInfo.maxredemptionvol)
                        ? this.redeemInfo.maxredemptionvol
                        : this.bankInfo.usableremainshare
                    : Number(this.bankInfo.usableremainshare) >
                      Number(this.fastRedeemData.maxfastredeem)
                    ? this.fastRedeemData.maxfastredeem
                    : this.bankInfo.usableremainshare;
            const _min =
                val === "0" ? this.redeemInfo.minredemptionvol : this.fastRedeemData.minamount;
            this.$set(this.limit, "min", _min);
            this.$set(this.limit, "max", _max);
            this.pla =
                Number(_min) < Number(_max)
                    ? "本次可赎回" + this.$util.fmtNum(_min) + "-" + this.$util.fmtNum(_max) + "份"
                    : "本次只可全部赎回剩余份额";
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
            }
        },
        "fundInfo.sharetype"(val) {
            if (val === "B") {
                this.feeGate = {};
            }
        },
        "fundInfo.sellTo"(val) {
            let _max = "";
            let _min = "";
            if (val === "1") {
                _max =
                    Number(this.bankInfo.usableremainshare) > Number(this.redeemInfo.xjbmax)
                        ? this.redeemInfo.xjbmax
                        : this.bankInfo.usableremainshare;
                _min = this.redeemInfo.xjbmin;
            } else {
                _max =
                    this.fundInfo.sell === "0"
                        ? Number(this.bankInfo.usableremainshare) >
                          Number(this.redeemInfo.maxredemptionvol)
                            ? this.redeemInfo.maxredemptionvol
                            : this.bankInfo.usableremainshare
                        : Number(this.bankInfo.usableremainshare) >
                          Number(this.fastRedeemData.maxfastredeem)
                        ? this.fastRedeemData.maxfastredeem
                        : this.bankInfo.usableremainshare;
                _min =
                    this.fundInfo.sell === "0"
                        ? this.redeemInfo.minredemptionvol
                        : this.fastRedeemData.minamount;
            }
            if (Number(_max) === 0 || this.$util.isEmpty(_max)) {
                // 没返回最大限额，最大值为可用份额
                _max = this.bankInfo.usableremainshare;
            }
            this.$set(this.limit, "min", _min);
            this.$set(this.limit, "max", _max);
            this.pla =
                Number(_min) < Number(_max)
                    ? "本次可赎回" + this.$util.fmtNum(_min) + "-" + this.$util.fmtNum(_max) + "份"
                    : "本次只可全部赎回剩余份额";
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
                this.queryRate();
            }
        },
        "fundInfo.amount"(val) {
            this.isAmount(val);
        }
    },
    mounted() {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        if (this.fund.fundArr.length > 0) {
            let fundArr = Object.assign([], this.fund.fundArr);
            let zx = [];
            this.fund.fundArr = this.fund.fundArr.filter(
                (fund) => fund.paycenterid !== this.$util.getConfig().const.ZX_CENTER
            );
            zx = fundArr.filter(
                (fund) => fund.paycenterid === this.$util.getConfig().const.ZX_CENTER
            );
            zx.forEach((item) => this.fund.fundArr.push(item));
        }
        this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
        // 查询现金宝信息
        this.cfgFundrealtimeQueryAll();
        this.getSellInfo();
        /* 判断是否开启普通T+0赎回和货币新规功能 */
        this.showSellType =
            this.$cache.getCompanyInfoParam("10301003").includes("A05") &&
            this.fund.fundtype === "04";
    },
    methods: {
        // 查询现金宝信息
        async cfgFundrealtimeQueryAll() {
            let xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
            this.xjbfundcode = xjbFundInfo.fundcode;
            if (!this.xjbfundcode || this.xjbfundcode === this.fund.fundcode) {
                this.$set(this.fundInfo, "sellTo", "2");
                return;
            }
            this.growthrate = xjbFundInfo.growthrate;
            // 赎回转购限额查询
            const res2 = await fundApi.combTransRedeemForBuyLimit({
                fundcode: this.fund.fundcode,
                targetfundcode: this.xjbfundcode
            });
            this.hasxjb = res2.data && res2.data.datalist && res2.data.datalist.length > 0;
            this.$set(this.fundInfo, "sellTo", this.hasxjb ? "1" : "2");
            this.redeemInfo.xjbmin =
                res2.data && res2.data.datalist[0].min ? res2.data.datalist[0].min : 0;
            this.redeemInfo.xjbmax = res2.data.datalist[0].max ? res2.data.datalist[0].max : 0;
        },
        async queryFundlimit() {
            if (!this.showSellType) return;
            let res = await fundApi.combQueryFundlimit({
                fundcode: this.fund.fundcode,
                transactionaccountid: this.bankInfo.transactionaccountid,
                bankcode: this.bankInfo.bankcode,
                businesscode: "098",
                invtp: "1",
                transflag: "1"
            });
            this.fastRedeemData = res.data || {};
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            if (
                Number(this.bankInfo.usableremainshare) - Number(this.fundInfo.amount) <
                    Number(this.redeemInfo.minaccountbalance) &&
                Number(this.fundInfo.amount) !== Number(this.bankInfo.usableremainshare)
            ) {
                this.$alert(
                    `最低可持有份额低于${this.redeemInfo.minaccountbalance}份，建议全部卖出`,
                    "温馨提示"
                );
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.fundInfo.sellTo === "1") {
                        // TODO 赎回至现金宝 暂不支持
                        this.$util.getSdxProtocol(
                            {
                                fundcode: this.xjbfundcode,
                                proto: "sell"
                            },
                            (res) => {
                                this.xjbFundRisk = res;
                                this.protocol = true;
                            }
                        );
                    } else {
                        this.sellFund(true);
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        async sellFund(val) {
            this.protocol = false;
            if (!val) return;
            let rs = await fundApi.redeemAsset({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype,
                transactionaccountid: this.bankInfo.transactionaccountid,
                sellmode: "2", // 赎回方式   1-现金宝 2-银行卡
                selltype: this.fundInfo.sell, // 赎回类型   0-普通赎回 1-快速赎回
                applicationvol: this.fundInfo.amount, // 输入框内的份额
                largeredemptionflag: this.fundInfo.largeredemptionflag, // 巨额赎回标志   字典：110051 0-放弃超额部分 1-继续赎回
                tradepassword: this.$util.enc(this.fundInfo.pwd),
                referid: "", // 推荐人代码
                referralname: "" // 推荐人姓名
            });
            if (rs.error) return;
            if (rs.data) {
                this.result.cla = "register-success";
                if (this.fundInfo.sell === "0") {
                    this.result.btnMsg =
                        "预计确认时间：" +
                        this.$util.fmtDate(rs.data.transactioncfmdate) +
                        "， 如遇节假日则顺延，请耐心等待";
                } else {
                    this.result.btnMsg = "预计确认时间：两小时内到账，请耐心等待";
                }
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + rs.msg;
            }
            this.result.msg =
                "您的赎回申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            this.buySuccess = true;
        },
        // 全部取现处理
        allSell() {
            this.fundInfo.amount = Number(this.bankInfo.usableremainshare) + "";
            this.$refs.fundInfo.validateField("amount");
            this.isAmountAll = true;
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.$set(this.fundInfo, "amount", _val);
            if (this.fundInfo.amount === this.bankInfo.usableremainshare) {
                this.isAmountAll = true;
            } else {
                this.isAmountAll = false;
            }
            this.query = setTimeout(() => {
                this.queryRate();
            }, 500);
        },
        // 费率入参获取
        async queryRate() {
            if (!Number(this.fundInfo.amount)) {
                this.feeGate = {};
                return;
            }
            this.$util.getFee(
                {
                    transactionaccountid: this.bankInfo.transactionaccountid,
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    businesscode: "24",
                    // paymode: "2",
                    applicationvol: this.fundInfo.amount,
                    channelid: this.fundInfo.channelid
                },
                (res) => {
                    this.feeGate = res;
                }
            );
        },
        amountLimit(rule, value, callback) {
            if (value === this.bankInfo.usableremainshare) {
                return callback();
            }
            rule.mes = "赎回份额";
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 赎回前数据查询
        async getSellInfo() {
            let rs = await fundApi.qryBeforeRedeem({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (rs.error) {
                return;
            }
            this.redeemInfo = rs.data;
            this.$set(
                this.fundInfo,
                "id",
                this.fund.fundArr[0].transactionaccountid + this.fund.fundArr[0].index
            );
            this.$set(this.fundInfo, "sharetype", this.fund.sharetype.substr(0, 1));
            this.$set(this.fundInfo, "sell", "0");
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";

.bizcomp-sell-fund {
    padding-bottom: 30px;
}
.common-question-contain {
    margin-top: 41px;
    padding: 0 20px;
}
.bank-img-sel {
    width: 400px !important;
}
</style>
